import type { TextVariant } from '@cartwhl/ui/base/Text';

import PresentationChainPill from '../../../presentations/ChainPill';
import { ROW_BADGE_HEIGHT_PX } from '../constants';

interface ChainPillProps {
  chainName: string;
  className?: string;
  textVariant?: TextVariant;
}

export default function ChainPill({
  chainName,
  className,
  textVariant = 'studio/body/medium/xs',
}: ChainPillProps) {
  return (
    <PresentationChainPill
      chainName={chainName}
      className={className}
      textVariant={textVariant}
      heightPx={
        textVariant === 'studio/body/medium/xs' ? ROW_BADGE_HEIGHT_PX : undefined
      }
    />
  );
}
